import { sanitizeHtml } from "../../utils/sanitizeHtml";

interface DescriptionProps {
  description: string;
}

export const Description = ({ description }: DescriptionProps) => (
  <div
    className="font-sans text-xs leading-4 font-medium [&_a]:text-primary-600"
    dangerouslySetInnerHTML={{ __html: sanitizeHtml(description) }}
  />
);
